module.exports = __webpack_public_path__ + "static/media/September_2026_5.a1d1cc26.webp";